import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";
import SEO from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";

const COPY = {
    en: { kicker: "404 · Not Found", h1: "This wire is not connected.", body: "The page you are looking for doesn't exist or was moved. Let's get you back to a powered circuit.", cta: "Return to Homepage" },
    de: { kicker: "404 · Nicht gefunden", h1: "Diese Leitung ist nicht angeschlossen.", body: "Die gesuchte Seite existiert nicht oder wurde verschoben. Wir bringen Sie zurück zum Hauptstromkreis.", cta: "Zur Startseite" },
    ro: { kicker: "404 · Pagină inexistentă", h1: "Acest fir nu este conectat.", body: "Pagina căutată nu există sau a fost mutată. Vă întoarcem la circuitul principal.", cta: "Înapoi la Pagina Principală" },
};

export default function NotFound() {
    const { lang } = useLang();
    const c = COPY[lang] || COPY.en;
    return (
        <main data-testid="page-404" className="min-h-screen bg-white pt-28 lg:pt-36 pb-20 blueprint-bg">
            <SEO pathKey="home" path="/" />
            <div className="mx-auto max-w-3xl px-6 lg:px-10">
                <div className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-steel-600 flex items-center gap-3">
                    <Construction className="h-4 w-4 text-signal" />
                    <span>{c.kicker}</span>
                </div>
                <h1
                    data-testid="not-found-title"
                    className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tighter text-navy leading-[0.92]"
                >
                    {c.h1}
                </h1>
                <p className="mt-8 max-w-xl text-steel-600 text-base lg:text-lg leading-relaxed">{c.body}</p>
                <div className="mt-10 flex flex-wrap gap-3">
                    <Link
                        to="/"
                        data-testid="not-found-cta"
                        className="group inline-flex items-center gap-3 bg-navy text-white px-7 py-4 font-mono-tech text-[12px] uppercase tracking-[0.2em] hover:bg-navy-light transition-colors"
                    >
                        <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
                        {c.cta}
                    </Link>
                </div>

                <div aria-hidden="true" className="mt-20 select-none pointer-events-none">
                    <div className="font-display leading-none text-navy/[0.06] text-[26vw] tracking-tighter">404</div>
                </div>
            </div>
        </main>
    );
}
